<template>
<v-dialog v-model="dialogDetailTask" persistent max-width="550" style="overflow-y: hidden;border-radius: 15px;" class="CSChatThai">
  <v-card>
    <v-card flat>
      <v-toolbar flat class="toolbar-card-v2">
        <v-toolbar-title class="CSChatThai">
          <span >{{$t('Task.detail.header')}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left v-if="!edit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon text v-bind="attrs" v-on="on">
              <v-icon style="color: black !important; font-size: 20px !important;">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="edit = !edit">
              <v-list-item-title>{{$t('Task.detail.menu.edit')}}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="delete_task()">
              <v-list-item-title>{{$t('Task.detail.menu.delete')}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn dark icon text @click="closeDialog">
          <v-icon style="color: black !important; font-size: 20px !important;">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text v-if="edit" style="overflow-y: scroll; height: 70vh;" class="pt-5">
        <v-layout column wrap>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.subject')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 10px;">
            <input type="text" :placeholder="$t('Task.create.placeholderSubject')" class="CSChatThai inputtaskweb" v-model="subject_task">
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.priority')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
              <v-btn text :class="(priority=='1')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '1';">
                <v-icon class="btn-pri1">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p1')}}
              </v-btn>
              <v-btn text :class="(priority=='2')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '2';">
                <v-icon class="btn-pri2">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p2')}}
              </v-btn>
              <v-btn text :class="(priority=='3')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '3';">
                <v-icon class="btn-pri3">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p3')}}
              </v-btn>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.startDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-dialog
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="start_date"
                transition="scale-transition"
                width="290px"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-bind="attrs"
                v-on="on"
                v-model="start_date"
                label=""
                readonly
              ></v-text-field>
              </template>
              <v-date-picker
                v-model="start_date"
                no-title 
                scrollable
                :allowed-dates="allowedDates"
                >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu1 = false" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
                <v-btn text color="primary" @click="$refs.menu1.save(start_date)" style="text-transform: none;">{{$t('AnswerQuestion.ok')}}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.endDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-dialog
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="end_date"
                transition="scale-transition"
                width="290px"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-model="end_date"
                label=""
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
              </template>

              <v-date-picker
                v-model="end_date"
                no-title scrollable
                :allowed-dates="allowedDatesEnd"
                :min="min_date_end"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false" style="text-transform: none;">{{$t('AnswerQuestion.cancel')}}</v-btn>
                <v-btn text color="primary" @click="$refs.menu2.save(end_date)" style="text-transform: none;">{{$t('AnswerQuestion.ok')}}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.description')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 20px;">
            <v-textarea
              :label="$t('Task.create.placeholderDescription')"
              no-resize
              style="width: 75%;"
              outlined
              height="80"
              rows=3
              hide-details
              v-model="detail_task"
            ></v-textarea>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.assign')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8>
            <v-autocomplete
              :items="member"
              v-model="selectemember"
              :label="$t('Task.create.placeholderAssign')"
              item-text="name"
              item-value="tokenuser"
              multiple
              chips
              :menu-props="{maxHeight:'auto'}"
              style=" width: 75%;"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selectemember"
                  :key="JSON.stringify(data.item)"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                  v-if="data.item.type !== 'bot'"
                >
                  <v-avatar>
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" :src='`${publicPath}/assets/img/default_profile/business-white.png`' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" :src='`${publicPath}/assets/img/default_profile/business-white.png`' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" :src='`${publicPath}/assets/img/default_profile/bot-white.png`' class="object-fit-img">
                    <img v-else :src='`${publicPath}/assets/img/default_profile/man-white.png`' class="object-fit-img">
                  </v-avatar>
                  <span class="text-overflow-chip">{{ data.item.name }}</span>
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar v-if="data.item.type !== 'bot'">
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" :src='`${publicPath}/assets/img/default_profile/business-white.png`' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" :src='`${publicPath}/assets/img/default_profile/business-white.png`' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" :src='`${publicPath}/assets/img/default_profile/bot-white.png`' class="object-fit-img">
                    <img v-else :src='`${publicPath}/assets/img/default_profile/man-white.png`' class="object-fit-img">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-if="data.item.type !== 'bot'" class="text-overflow">{{data.item.name}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex sm4 md4 xl4 lg4 class="textSubject">
            <span>{{$t('Task.create.status')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
            <v-select
            :items="state"
            v-model="state_id"
            outlined
            hide-details
            item-text="name"
            item-value="state_id"
            style="padding:0; width: 100%;"
          ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-end justify-center class="" style="margin-top: 15px;">
          <v-btn class="btncancle" @click="cancel_task()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          <v-btn class="btncreate" @click="edit_task()" :loading="isloading"
          :disabled="subject_task == '' || priority == undefined || start_date == '' || end_date == ''">{{$t('AnswerQuestion.keep')}}</v-btn>
        </v-layout>
    </v-card-text>
    <v-card-text v-else style="overflow-y: scroll; height: 70vh;" class="CSChatThai pt-5">
      <v-layout justify-center align-center v-if="progress" style="height: 100% !important;">
        <v-progress-circular size="100" color="primary" :indeterminate="progress"></v-progress-circular>
      </v-layout>
      <v-layout column wrap class="mb-2" v-else>
        <v-row>
          <v-flex sm1>
            <v-icon style="padding-top: 10px;" :class="'btn-pri'+ priority" >mdi-checkbox-blank</v-icon>
          </v-flex>
          <v-flex d-flex sm11 xs12>
            <v-row class="pl-2">
              <v-flex sm12 xs12>
                <h3 style="color: #003459;" class="mb-0">{{infor_task.title}}</h3>
              </v-flex>
              <v-flex sm12 xs12>
                <v-chip class="ma-2" label text-color="white" small style="margin: 0 !important; !important; background: #e6ecf3 !important; color: #51819e !important; font-weight: 700;">
                  {{state_name}}
                </v-chip>
                <span class="mb-0 ml-1" style="font-size: 12px; color: #a6a6a6;" v-if="start_date || end_date">{{formatDate(start_date)}} <span v-if="start_date && end_date"> - </span> {{formatDate(end_date)}}
                </span>
              </v-flex>
            </v-row>
          </v-flex>
        </v-row>
          <v-flex sm12 md12 xl12 lg12 style="margin-top: 10px;" v-if="infor_task.detail">
            <div class="descriptionTask mt-3">
            <read-more class="mb-0 font-size-15" :more-str="$t('ChatSide.Read.readmore')" :text="infor_task.detail ? infor_task.detail: '-'" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100"></read-more>
            <v-btn small v-if="infor_task.sign_info != undefined" class="btn-sign-doc" @click="sign_doc(infor_task.sign_info)">{{infor_task.sign_info.label}}</v-btn>
          </div>
          </v-flex>

          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-15">{{$t('Task.detail.createBy')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-chip style="background: #e6ecf3 !important;">
            <v-avatar>
              <img :src="profilepicture" v-if="profilepicture" class="object-fit-img">
              <img :src='`${publicPath}/assets/img/default_profile/man-white.png`' v-else class="object-fit-img">
            </v-avatar>
            <span class="text-overflow-chip pl-2">
              {{nickname}}
            </span>
            </v-chip>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-15">{{$t('Task.create.assign')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-chip v-for="(item,index) in infor_task.assign" style="background: #e6ecf3 !important;" :key="index">
            <v-avatar class="teal">
              <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
              <img :src='`${publicPath}/assets/img/default_profile/man-white.png`' v-else-if="item.type == 'user'" class="object-fit-img">
              <img :src='`${publicPath}/assets/img/default_profile/bot-white.png`' v-else-if="item.type == 'bot'" class="object-fit-img">
              <img :src='`${publicPath}/assets/img/default_profile/man-white.png`' v-else class="object-fit-img">
            </v-avatar>
            <span class="text-overflow-chip pl-2">
              {{item.nickname}}
            </span>
            </v-chip>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubjectDetail">
            <span class="font-size-16">{{$t('Task.create.comment')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top: 15px !important;">
            <v-layout row wrap class="mb-2 ml-2" align-center justify-end>
              <v-textarea
                :label="$t('Task.create.placeholderComment')"
                no-resize
                style="width: 75%; margin-right: 10px;"
                outlined
                height="80"
                rows=3
                hide-details
                v-model="comment_task"
              ></v-textarea>
              <v-btn small class="btncreate-comment" @click="add_comment()" :disabled="comment_task == ''">{{$t('AnswerQuestion.keep')}}</v-btn>
            </v-layout>
            <v-col cols="12">
              <v-card class="card-comment" v-for="(item, index) in listcomment" :key="index">
                <v-row class="pa-3">
                  <v-col cols="2" class="mt-3 ml-2">
                    <v-avatar size="40px">
                      <img :src="item.path_pic" alt="alt" v-if="item.path_pic" class="object-fit-img">
                      <img :src='`${publicPath}/assets/img/default_profile/man-white.png`' alt="alt" v-else class="object-fit-img">
                    </v-avatar>
                  </v-col>
                  <v-col cols="8" class="pa-0">
                    <v-card-title primary-title class="pa-0">
                      <div class="ml-3" style="width: 100%;">
                        <div class="text-overflow-comment">{{item.nickname}}</div>
                        <read-more style="width: 160px !important;" class="mb-0 mr-5" :more-str="$t('ChatSide.Read.readmore')" :text="item.comment" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="80"></read-more>
                      </div>
                    </v-card-title>
                  </v-col>
                  <v-col cols="1">
                    <v-btn color="black" slot="activator" icon text @click="delete_commemt(item.comment_id)">
                      <v-icon style="color: rgba(0,0,0,.87); font-size: 16px;">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-flex>
      </v-layout>
    </v-card-text>
    <WebviewBigDialog :dialogWebviewbig="dialogWebviewbig" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialog>
  </v-card>
</v-dialog>
</template>
<script>
// import { Decode } from '@/services'
import WebviewBigDialog from '@/components/dialog/WebviewBigDialog'

var _ = require('lodash')
export default {
  props: {
    dialogDetailTask: false,
    taskid: '',
    roomid: ''
    // projectid: ''
  },
  components: {
    WebviewBigDialog
  },
  data: () => ({
    publicPath: process.env.VUE_APP_BASE_PATH,
    Webview_item: {},
    dialogWebviewbig: false,
    projectid: '',
    infor_task: {},
    edit: false,
    detail_task: '',
    token: '',
    subject_task: '',
    menu1: false,
    menu2: false,
    start_date: '',
    end_date: '',
    priority: null,
    member: [],
    selectemember: [],
    isloading: false,
    state: [],
    state_id: '',
    member: [],
    old_state: '',
    min_date: '',
    max_date: '',
    min_date_end: '',
    profilepicture: '',
    nickname: '',
    state_name: '',
    progress: false,
    listcomment: [],
    comment_task: '',
    data_user: {},
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
  }),
  created () {
    // var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.token = decoded['tokenuser']
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.token = this.data_user.tokenuser
  },
  mounted () {
  },
  methods: {
    get_comment () {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_comment_by_id', {
        tokenuser: this.token,
        task_id: this.taskid
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status == 'success') {
          this.listcomment = response.data.data
          this.listcomment = _.reverse(_.sortBy(this.listcomment, function (dateObj) {
            return new Date(dateObj.timestamp)
          }))
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    add_comment () {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/comment_task', {
        tokenuser: this.token,
        task_id: this.taskid,
        comment: this.comment_task
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data)
          this.listcomment.unshift(response.data.data)
          this.$swal('', this.$t('Alert.Success.createComment'), 'success')
          this.comment_task = ''
          this.$emit('commenttask', { 'task_id': this.taskid, 'count_comment': this.listcomment.length, 'state_id': this.state_id, 'project_id': this.projectid })
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    delete_commemt (commentid) {
      this.$swal({
        text: this.$t('Alert.Task.removeComment'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/delete_comment', {
            tokenuser: this.token,
          	comment_id: commentid
          }).then((response) => {
            if (response.data.status === 'success') {
              var index = ''
              index = _.findIndex(this.listcomment, function(o) { return o.comment_id == commentid })
              this.listcomment.splice(index, 1)
              this.$swal('', this.$t('Alert.Success.removeComment'), 'success')
              this.$emit('commenttask', { 'task_id': this.taskid, 'count_comment': this.listcomment.length, 'state_id': this.state_id, 'project_id': this.projectid })
            }
          }).catch(error => {
            console.log(error.message)
          })
        }
      })
    },
    sign_doc (item) {
      // console.log(item)
      if (item.type == 'webview') {
        this.Webview_item = item
        this.dialogWebviewbig = true
        this.closeDialog()
      } else if (item.type == 'link') {
        window.open(item.url, '_blank')
      }
    },
    formatDate (input) {
      if (input.match(/\d+/g) !== null && input.match(/\d+/g) !== 'null') {
        var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];

        return day+'/'+month+'/'+year;
      } else {
        return '-'
      }
    },
    closeWebview (value) {
      this.dialogWebviewbig = value
    },
    allowedDates (val) {
      this.min_date_end = this.start_date
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date
      }
      return this.min_date_end
    },
    allowedDatesEnd (val) {
      this.min_date_end = this.start_date
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end
      }
      return this.end_date
    },
    closeDialog () {
      this.selectemember = []
      this.detail_task = ''
      this.subject_task = ''
      this.edit = false
      this.state_id = ''
      this.$emit('closeDetailTask', false)
    },
    cancel_task () {
      this.start_date =  this.infor_task.time_start.split(' ')[0]
      this.end_date =  this.infor_task.time_end.split(' ')[0]
      this.edit = false
      this.isloading = false
    },
    edit_task () {
      // var today = new Date();
      // var time = today.getHours() + "00:00:00" + today.getMinutes() + ":" + today.getSeconds();
      var time = "00:00:00.00"
      this.isloading = true
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/edit_task', {
        tokenuser: this.token,
        tokenroom: this.roomid,
      	title: this.subject_task,
      	detail: this.detail_task,
      	state_id: this.state_id,
      	time_start: this.start_date + ' ' + time,
      	time_end: this.end_date + ' ' + time,
      	priority: this.priority,
      	project_id: this.projectid,
      	assign: this.selectemember,
        task_id: this.taskid
      }).then((response) => {
        if (response.data.status === 'success') {
          this.isloading = false
          this.$swal('', this.$t('Alert.Success.editTask'), 'success')
          this.$emit('edittask', {'task_id': this.taskid, 'state_id': this.state_id, 'event': 'edit', 'old_state': this.old_state})
          this.closeDialog()
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    delete_task () {
      this.$swal({
        text: this.$t('Alert.Task.remove'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/delete_task', {
            tokenuser: this.token,
          	tokenroom: this.roomid,
          	list_task_id: [this.taskid]
          }).then((response) => {
            if (response.data.status === 'success') {
              // console.log(response.data.data)
              // console.log(this.taskid)
              this.isloading = false
              this.$swal('', this.$t('Alert.Success.removeTask'), 'success')
              this.$emit('deletetask', {'task_id': this.taskid, 'state_id': this.old_state, 'event': 'delete', 'project_id': this.projectid})
              this.closeDialog()
            }
          }).catch(error => {
            console.log(error.message)
          })
        }
      })
    },
    get_member () {
      // console.log(this.roomid)
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          var member_active = []
          member_active = response.data.data_room
          this.member = _.filter(member_active, function(o) { return o.type !== 'bot' && o.type !== 'business' && o.statemember == 'active' })
          this.member.push({
            tokenuser: this.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          })
          // intersection เพราะเวลาที่มีคนออกจากกลุ่มแล้วทำให้แก้ไข task ไม่ได้
          this.selectemember = _.map(_.intersectionBy(this.member, this.infor_task.assign, 'tokenuser'), 'tokenuser')
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    getstate () {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.roomid,
        project_id: this.projectid
      }).then((response) => {
        this.state = response.data.data.state
        // this.state_id = response.data.data.state[0].state_id
      }).catch(error => {
        console.log(error.message)
      })
    },
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    selectemember () {
      // console.log(this.selectemember)
    },
    state_id () {
      // console.log(this.state_id)
    },
    dialogDetailTask () {
      // this.infor_task = {}
      if(this.dialogDetailTask) {
        this.progress = true
        this.infor_task = {}
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: this.taskid
        }).then((response) => {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.infor_task = response.data.data
            // console.log(this.infor_task.assign)
            this.old_state = this.infor_task.state.id
            this.state_id = this.infor_task.state.id
            this.projectid = this.infor_task.project_id
            this.subject_task = this.infor_task.title
            this.priority = this.infor_task.priority
            this.start_date =  this.infor_task.time_start.split(' ')[0]
            this.end_date =  this.infor_task.time_end.split(' ')[0]
            this.detail_task = this.infor_task.detail
            this.profilepicture = this.infor_task.owner_info.path_pic
            this.nickname = this.infor_task.owner_info.nickname
            this.state_name = this.infor_task.state.name
            // this.selectemember = _.map(this.infor_task.assign, 'tokenuser')
            this.getstate()
            this.get_member()
            this.get_comment()
          }
        }).catch(error => {
          console.log(error.message)
          console.log(error.response.data.message)
          if (error.response.data.message == 'Not found task.') {
            this.progress = false
            this.dialogDetailTask = false
            this.closeDialog()
            this.$swal('', this.$t('Alert.Fail.Task.removed'), 'warning')
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
/* p {
  margin-bottom: 0px !important;
  margin-right: 34px !important;
} */
.text-overflow-comment {
  font-weight: 600 !important;
  color: #003559 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 160px !important;
}
.card-comment {
  /* height: 60px !important; */
  /* width: 370px !important; */
  width: 80% !important;
  border-radius: 6px !important;
  border-color: #e0e0e0 !important;
  border-style: solid !important;
  border-width: thin !important;
  box-shadow: none !important;
  margin-bottom: 5px !important;
  margin-right: 5px !important;
}
.btn-sign-doc {
  /*background-color: #1c78ec !important;*/
  background-color: white !important;
    /* width: 225px !important; */
    text-align: center;
    border-radius: 5px !important;
    color: #1c78ec !important;
    text-transform: none !important;
    border: 1px solid #1c78ec;
    box-shadow: none !important;
}
.font-size-15 {
  font-size: 15px !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-input .v-label {
  height: 25px !important;
  line-height: 24px !important;
}
>>>.v-text-field--outline .v-input__slot {
  min-height: 50px !important;
}
.system-bar {
  height: 2px !important;
  border-radius: 10px !important;
  width: 400px !important;
  margin-left: 55px !important;
  background-color: #d8d8d8 !important;
}
>>>.v-btn-toggle--selected {
  box-shadow: none !important;
}
.text-overflow-chip {
  /* margin-top: 10px !important; */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 70px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
}
.selectedPriority {
 border-radius: 5px;
 border: 1px solid #979797;
}
.btn-pri1 {
  /*width: 80px !important;*/
  color: #b3493d !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri2 {
  /*width: 80px !important;*/
  color: #fcbe55 !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri3 {
  /*width: 80px !important;*/
  color: #a0a1a3 !important;
  /*border-radius: 4px !important;*/
  font-size: 34px !important;
}
.btn-pri1-show {
  width: 60px !important;
  background-color: #b3493d !important;
  border-radius: 4px !important;
  height: 32px !important;
}
.btn-pri2-show {
  width: 60px !important;
  background-color: #fcbe55 !important;
  border-radius: 4px !important;
  height: 32px !important;
}
.btn-pri3-show {
  width: 60px !important;
  background-color: #a0a1a3 !important;
  border-radius: 4px !important;
  height: 32px !important;
}
>>>.v-input__slot {
  border-radius: 6px !important;
  /* border-color: #949494 !important;
  border-style: solid !important;
  border-width: thin !important; */
  border-width: thin !important;
  box-shadow: none !important;
}
.height-600px {
  height: 600px !important;
}
.toolbar-card {
  background-color: #1e2227 !important;
}
.toolbar-card-v2 {
  height: 64px !important;
  background-color: white !important;
}
.btncreate {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  /* background: #2562af !important; */
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 90px !important;
  text-transform: none;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 90px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}
.text-transform {
  text-transform: capitalize !important;
}
.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  /* background-image: url('/static/img/default_profile/group-white.png'); */
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>>.trix-content {
    height: 220px !important;
}
>>>trix-editor:empty:not(:focus)::before {
    content: attr(placeholder);
    color: #858585;
    font-size: 16px;
    cursor: text;
}
>>>.trix-button-group--file-tools {
  display: none;
}
.attachment_file {
  border-radius: 3px;
  border: #bbbbbb 1px solid;
  background: #eee;
  width: fit-content;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
}
>>>.inputtaskweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 100% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.inputtaskwebDetail {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 75% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
  background: #e0e0e059 !important;
}
.textSubject {
  margin-top: 6px;
  text-align: left;
  padding-right: 20px;
  font-size: 16px;
}
.textSubjectDetail {
  /* padding-left: 45px; */
  /* padding-left: 35px; */
  margin-top:20px;
  color: #003459;
  font-weight: 600;
  font-size: 16px;
}
.btncreate-comment {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 90px !important;
  text-transform: none;
}
input[type=text]:focus {
    outline: none !important;
}
textarea[type=text]:focus {
    outline: none !important;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    border: 1px #979797 solid;
}
.descriptionTask {
  border-radius: 5px;
  border: 1px solid #00345961;
  padding: 10px;
  width: 80%;
  margin-left: 30px;
}


</style>
